module.exports = __webpack_public_path__ + "static/media/differential.e4f76756.svg";